import classNames from 'classnames';
import { type CSSProperties, useId } from 'react';
import { LayoutStack } from '../layouts';
import { WaveyWrapperProps } from './types';
import styles from './WaveyWrapper.module.css';
function clipPathFragmentId(reactId: string, suffix: string) {
  return `${reactId.replaceAll(':', '')}-${suffix}`;
}
function WaveyWrapper({
  children,
  bright = false,
  topOnly,
  bottomOnly,
  className,
  space = 'none'
}: WaveyWrapperProps) {
  const reactId = useId();
  const waveTopId = clipPathFragmentId(reactId, 'wave-top');
  const waveBottomId = clipPathFragmentId(reactId, 'wave-bottom');
  return <LayoutStack space="none" className={classNames(styles.outerContainer, {
    [styles.bright!]: bright,
    [styles.dark!]: !bright,
    [styles.bottomOnly!]: bottomOnly,
    [styles.topOnly!]: topOnly
  })} style={{
    '--space': `var(--betterplace-spacing-${space})`,
    '--clip-wave-top': `url(#${waveTopId})`,
    '--clip-wave-bottom': `url(#${waveBottomId})`
  } as CSSProperties}>
      <LayoutStack space="400" className={classNames(styles.contentContainer, className)}>
        {children}
      </LayoutStack>
      <svg width="0" height="0" style={{
      position: 'absolute',
      pointerEvents: 'none',
      overflow: 'hidden'
    }} aria-hidden="true" focusable="false">
        <defs>
          <clipPath id={waveBottomId} clipPathUnits="objectBoundingBox">
            <path d="M516.587 43.9739C285.382 42.5668 75.8601 86.0717 0 108V0H1440V43.9739C1377.92 61.2794 1193.5 77.3003 1101.65 77.7459C884.14 78.8013 805.594 45.7329 516.587 43.9739Z" transform="scale(0.000694444,0.0092592593)" />
          </clipPath>
          <clipPath id={waveTopId} clipPathUnits="objectBoundingBox">
            <path d="M516.587 0.03332959C285.382 -1.37257 75.8601 42.092 0 64H1440V26.0352C1392.17 26.0352 1275.66 32.9305 1101.65 33.774C884.14 34.8284 805.594 1.79062 516.587 0.03332959Z" transform="scale(0.000694444,0.015625)" />
          </clipPath>
        </defs>
      </svg>
    </LayoutStack>;
}
export default WaveyWrapper;